import React from 'react';
import { Card, Button, toast } from 'nelitomorphism';
import './Contact.css';

export const EMAIL = 'nelitojr55@gmail.com';
export const LOCATION = 'Florianópolis, SC · Brazil';

const Contact = () => {
  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      toast('Email copied', { tone: 'ok', detail: EMAIL });
    } catch {
      window.location.href = `mailto:${EMAIL}`;
    }
  };

  return (
    <section id="contact">
      <Card glow title="Contact" meta="get in touch">
        <div className="contact-body">
          <div>
            <p className="contact-lead">
              I'm at Fuel Network and not job hunting. But if you are building
              something interesting, my inbox is open.
            </p>
            <p className="contact-meta">{LOCATION}</p>
          </div>

          <div className="contact-actions">
            <Button
              variant="primary"
              size="md"
              onClick={() => {
                window.location.href = `mailto:${EMAIL}`;
              }}
            >
              Send an email
            </Button>
            <Button size="md" onClick={copyEmail}>
              Copy address
            </Button>
          </div>

          <a className="contact-email" href={`mailto:${EMAIL}`}>
            {EMAIL}
          </a>
        </div>
      </Card>
    </section>
  );
};

export default Contact;
